module.exports = __webpack_public_path__ + "static/img/200082.4b7b98a7.png";